<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useSdk } from '@fondationcss/sdk';

const sdk = useSdk();
const ready = ref(false);

onMounted(async () => {
  if (!sdk.settings.value) {
    await sdk.initialize({ apiUrl: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'https://localhost:11443/api' : undefined) });
  }
  ready.value = true;
});
</script>

<template>
  <div class="play-layout">
    <RouterView v-if="ready" />
  </div>
</template>

<style scoped>
.play-layout {
  min-height: 100vh;
  width: 100%;
}
</style>
